import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

/**
 * Tracks the URL the user was on before the current page, so any view can
 * answer "where did the user come from?" without every caller having to pass
 * an explicit origin. Used by the training details page to build an
 * origin-aware breadcrumb / back button.
 */
@Injectable({ providedIn: 'root' })
export class NavigationOriginService {
  private currentUrl: string = '';
  private previousUrl: string = '';

  constructor(private router: Router) {
    this.currentUrl = this.router.url;

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        const url = e.urlAfterRedirects || e.url;

        // Re-navigating to the same page (e.g. a query-param / replaceUrl
        // change) must not overwrite the remembered origin.
        if (this.stripQuery(url) === this.stripQuery(this.currentUrl)) {
          this.currentUrl = url;
          return;
        }

        this.previousUrl = this.currentUrl;
        this.currentUrl = url;
      });
  }

  /** Full URL (with query string) of the page visited before the current one. */
  getPreviousUrl(): string {
    return this.previousUrl;
  }

  private stripQuery(url: string): string {
    return (url || '').split('?')[0];
  }
}
